var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"posts-comp"},[_c('component-title',{attrs:{"title":"News","subtitle":"Lates news from our social media"}}),_vm._v(" "),_c('div',{staticClass:"posts-flex"},_vm._l((_vm.posts),function(post){return _c('div',{key:post.embedded_code,staticClass:"post",domProps:{"innerHTML":_vm._s(post.embedded_code)}})}),0)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67002b0b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Posts.vue
// module id = null
// module chunks = 